import { Component, Input } from '@angular/core';

@Component({
  selector: 'itl-desktop-new-detail-item',
  templateUrl: './desktop-new-detail-item.component.html',
  styleUrls: ['./desktop-new-detail-item.component.scss'],
})
export class DesktopNewDetailItemComponent {
  @Input() icon: string;
  @Input() iconColor: string;
  @Input() title: string;
}
